import React, { useEffect, useState } from 'react';
import './style.css';
import { useParams, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import SearchBox from '../Shared/SearchBox';
import { CampaignListActions, ConstantActions, LeadFormActions } from '../../Services/_actions';
import {
  leadAllCountsAtom,
  leadDetailObjAtom,
  phoneNumberForFormAtom,
  userDetailAtom,
  userInfoByNumberAtom,
  userInformationAtom,
  dynamicLeadFormAtom,
  knowlarityApiResponseAtom,
  userStaticFormData,
  userRawLeadFormDataAtom,
  userInfoFormEnableDisableAtom,
  leadFormQuickTemplateAtom,
  referenceFieldAtom,
  formEnableDisableAtom,
  campaignLeadManagementAtom,
} from '../../Services/_states';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import {
  USATimeZone,
  dateFormate,
  indianTimeZone,
  isValidPhoneNumber,
  renderToolTip,
  isValidNumber,
} from '../../utils/helper';
import { ImageModal } from '../Modals/ImageModal/index';
import { AudioModal } from '../Modals/AudioModal/index';
import { DispositionModal } from '../Modals/DispositionModal';
const ModalForms = React.lazy(() => import('../../components/Shared/Modals'));
const ReferenceForm = React.lazy(() => import('./ReferenceForm'));
import SelectDropdown from '../Shared/SelectDropdown/index';
import CampaignFormSelectionModal from './CampaignFormSelectionModal.tsx';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  FormHelperText,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CreateSupplierModal from './CreateSupplierModal.tsx';
import ConfirmBox from '../FlowBuilder/Common/ConfirmBox/index.tsx';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
import LoadingButton from '../Shared/Loading/index.tsx';
import LeadsDropdown from '../Shared/WebFormLeadsDrodown/index.tsx';
import SearchableDropdown from '../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import CommentBox from '../Shared/CommentBox/index.tsx';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CommonBadges from '../Shared/Badges/index.jsx';
import AssignLeadsModal from '../Leads/AssignLeadsModal.tsx';
import {
  BLOCKED_EXTENSIONS,
  WHATSAPP_ALLOWED_MIME,
  WHATSAPP_LIMITS,
} from '../Whatsapp/Template/template.constant.js';
import FileInput from '../Shared/FileUploadPreview/FileInput.jsx';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import WestOutlinedIcon from '@mui/icons-material/WestOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { EllipsisWithTooltip } from '../Shared/Tables/TableV1.tsx';
import { groupLeadItems, staticColumnsMatch } from '../Leads/DynamicFormFields/helper.ts';

export default function DetailView({ onLeadClick }) {
  const constantActions = ConstantActions();
  const leadFormActions = LeadFormActions();
  const campaignActions = CampaignListActions();
  const { phone_number, leadId } = useParams();
  const navigate = useNavigate();
  const loggedInUser = useRecoilValue(userInformationAtom);
  const setDynamicLeadForm = useSetRecoilState(dynamicLeadFormAtom);
  const resetDynamicForm = useResetRecoilState(dynamicLeadFormAtom);
  const [leadDetails, setLeadDetail] = useRecoilState(leadDetailObjAtom);
  const setleadCounts = useSetRecoilState(leadAllCountsAtom);
  const leadCounts = useRecoilValue(leadAllCountsAtom);
  const [userDetailByNumber, setUserDetailByNumber] = useRecoilState(userInfoByNumberAtom);
  const setUserDetail = useSetRecoilState(userDetailAtom);
  const phoneNumberForForm = useRecoilValue(phoneNumberForFormAtom);
  const [campaignList, setCampaignList] = useState({});
  const [formList, setFormList] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [knowlarityApiResData, setKnowlarityApiResData] = useRecoilState(knowlarityApiResponseAtom);
  const [modalShow, setModalShow] = React.useState(false);
  const [audioModalShow, setAudioModalShow] = React.useState(false);
  const [statusList, setStatusList] = React.useState([]);
  const [imagesList, setImagesList] = React.useState([]);
  const [audioList, setAudioList] = React.useState([]);
  const [commentList, setCommentList] = React.useState([]);
  const [comment, setComment] = React.useState('');
  const [showLastComment, setShowLastComment] = React.useState(true);
  const [openSupplierInfo, setOpenSupplierInfo] = React.useState(true);
  const [openLeadInfo, setOpenLeadInfo] = React.useState(true);
  const [openReference, setOpenReference] = React.useState(false);
  // const [searchValue, setSearchValue] = React.useState('');
  const [searchValue, setSearchValue] = React.useState(
    phone_number && isValidNumber(phone_number) ? phone_number : ''
  )
  const setCampaignLeadManagementData = useSetRecoilState(campaignLeadManagementAtom);

  const [filterForCamapign, setFilterForCamapign] = React.useState({
    to: loggedInUser?.id,
    include_assigned_by: 0,
    fetch_all: 0,
    next_page: 1,
    search: '',
  });
  const [dispositionModalShow, setDispositionModalShow] = useState(false);
  // const [timerForSaveCdr, setTimerForSaveCdr] = useState(120);
  // const [isTimerActive, setIsTimerActive] = useState(false);
  const [campaignFormModalProps, setCampaignFormModalProps] = useState({
    open: false,
    isEdit: false,
    formData: null,
  });
  // const [isEditCampaignForm, setIsEditCampaignForm] = useState(true);
  const [createSupplierModalProps, setCreateSupplierModalProps] = useState({
    open: false,
    isEdit: false,
    formData: null,
  });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [userRawLeadData, setUserRawLeadData] = useRecoilState(userRawLeadFormDataAtom);
  const setUserFormEnable = useSetRecoilState(userInfoFormEnableDisableAtom);
  const { showSnackBar } = useSnackBar();
  const [cdrDataIsSaving, setCdrDataIsSaving] = useState(false);
  const [leadFormTemplate, setLeadFormTemplate] = useRecoilState(leadFormQuickTemplateAtom);
  const [accordianKey, setAccordianKey] = useState('0');
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [isWaitingForLocalStorage, setIsWaitingForLocalStorage] = useState(false);

  const mapData = (formData) => {
    return formData?.map((item) => {
      if (item?.column_name === 'supplier_id') {
        return { ...item, value: searchValue?.toString() };
      }
      return { ...item };
    });
  };

  const handleConfirm = async (confirmed) => {
    // Yes flow temporarily disabled; auto-run "No" flow.
    if (confirmed) {
      // const leadWebFormData = JSON.parse(localStorage.getItem('leadWebFormData'));
      // const data =
      //   userRawLeadData?.data?.length < 1
      //     ? mapData(userStaticFormData)
      //     : mapData(userRawLeadData?.data);
      // setUserRawLeadData({ ...userRawLeadData, data: data, isCreateNewUser: true });
      // setUserDetailByNumber({
      //   leadform_Id: leadWebFormData?.webForm?.leads_form_id,
      //   campaign_id: leadWebFormData?.campaign?.proposal_id,
      //   phone_number: searchValue || '',
      // });
      // setUserDetail({ phone_number: searchValue || '' });
      // setUserFormEnable(false);
    } else {
      const leadWebFormData = JSON.parse(localStorage.getItem('leadWebFormData'));

      setSearchValue('');
      setUserDetail({});
      setLeadDetail({});
      resetDynamicForm();

      if (leadWebFormData?.campaign?.proposal_id && leadWebFormData?.webForm?.leads_form_id) {
        setUserDetailByNumber({
          campaign_id: leadWebFormData.campaign.proposal_id,
          leadform_Id: leadWebFormData.webForm.leads_form_id,
        });
      }

      // Clear phone number from localStorage
      if (leadWebFormData) {
        leadWebFormData.phoneNumber = '';
        localStorage.setItem('leadWebFormData', JSON.stringify(leadWebFormData));
      }
    }
    setConfirmOpen(false);
  };
  const getRawLeadForm = async () => {
    try {
      const response = await leadFormActions.getRawLeadForm(); // Fixed typo here
      if (response.status === 200 && response?.data?.data) {
        // Fixed variable name and checked for response.data
        setUserRawLeadData({ ...response?.data });
      } else if ([400, 401, 403].includes(response.status)) {
        showSnackBar('An error occurred while fetching the form.', 'error');
      }
    } catch (error) {
      showSnackBar(error?.toString() || 'An unexpected error occurred', 'error');
    }
  };

  const handleSearch = async (e) => {
    try {
      const leadWebFormData = JSON.parse(localStorage.getItem('leadWebFormData'));

      if (!e || e.trim() === '') {
        setSearchValue('');
        setLeadDetail({});
        setUserDetail({});
        resetDynamicForm();

        // ✅ FIX: Keep userDetailByNumber with form info and reload template
        if (leadWebFormData?.campaign?.proposal_id && leadWebFormData?.webForm?.leads_form_id) {
          setUserDetailByNumber({
            leadform_Id: leadWebFormData?.webForm?.leads_form_id,
            campaign_id: leadWebFormData?.campaign?.proposal_id,
          });
        } else {
          setUserDetailByNumber({});
        }

        if (leadWebFormData) {
          leadWebFormData.phoneNumber = '';
          localStorage.setItem('leadWebFormData', JSON.stringify(leadWebFormData));
        }
        return;
      }

      // ... rest of handleSearch remains the same
      if ((/^\d+$/.test(e) && e?.length <= 13) || !e) {
        resetDynamicForm();
        setSearchValue(e);
        setUserDetail({});
        if (leadWebFormData) {
          leadWebFormData.phoneNumber = '';
          localStorage.setItem('leadWebFormData', JSON.stringify(leadWebFormData));
        }
      }

      if (isValidNumber(e) && e?.length >= 10 && e?.length <= 13) {
        let res = await leadFormActions.getDetailsByNumber(e);

        if (res?.status === 200) {
          if (res?.data === 'Not found') {
            handleConfirm(false);
            getRawLeadForm();
            resetDynamicForm();
            showSnackBar('User not found', 'warning');
            return;
          }

          let data = { ...res?.data };
          let updateData = [...data?.data];
          updateData?.forEach((element) => {
            if (element?.column_name === 'supplier_id') {
              data['supplier_id'] = element['value'] || '';
            }
            if (element?.column_name === 'city') {
              data['city'] = element['value'] || '';
            }
            if (element?.column_name === 'area') {
              data['area'] = element['value'] || '';
            }
          });
          setUserRawLeadData({ ...data, data: updateData });
          data = {
            ...data,
            leadform_Id: leadWebFormData?.webForm?.leads_form_id || '',
            campaign_id: leadWebFormData?.campaign?.proposal_id || '',
            leadId: leadId,
          };
          setUserDetailByNumber(data);
        } else {
          showSnackBar('Error occurred', 'warning');
        }

        setUserDetail({ phone_number: e });
        if (leadWebFormData) {
          leadWebFormData.phoneNumber = e;
          localStorage.setItem('leadWebFormData', JSON.stringify(leadWebFormData));
        }
      }
    } catch (error) {
      showSnackBar(error?.toString() || 'An unexpected error occurred', 'error');
    }
  };

  const getStatusList = async (leadFormId) => {
    try {
      const payload = {
        active: { value: true },
        leadFormId: leadFormId,
      };
      if (statusList?.length > 0) return;
      const res = await leadFormActions.fetchStatusAndSubStatus(payload);
      if (res?.status === 200) {
        setStatusList([...res?.data]);
        setCampaignLeadManagementData((prev) => ({
          ...prev,
          statusData: {
            ...prev.statusData,
            [leadFormId]: res.data,
          },
        }));
      }
    } catch (error) {
      console.warn(error);
    }
  };

  const handleChangeDate = async (e) => {
    setLeadDetail({ ...leadDetails, next_action_date: e });
    await leadFormActions.updateLeadStatusDate({
      next_action_date: e,
      id: leadDetails?.id,
    });
  };

  const getImagesById = async () => {
    setModalShow(true);
    let res = await leadFormActions.getLeadImagesById(leadDetails?.id);
    setImagesList(res?.data?.image_funnel || []);
  };

  const inferDocType = (mime) => {
    if (WHATSAPP_ALLOWED_MIME.image.includes(mime)) return 'image';
    if (WHATSAPP_ALLOWED_MIME.video.includes(mime)) return 'video';
    if (WHATSAPP_ALLOWED_MIME.audio.includes(mime)) return 'audio';
    if (WHATSAPP_ALLOWED_MIME.file.includes(mime)) return 'file';
    return null;
  };
  const bytesToMB = (bytes) => (bytes / (1024 * 1024)).toFixed(2);

  const handleFileSelect = async (e) => {
    let file = e?.target?.files[0];
    if (!file) return;
    const fileName = file?.name?.toLowerCase();
    const ext = fileName.split('.').pop();
    if (BLOCKED_EXTENSIONS.has(ext)) {
      showSnackBar(`"${ext}" files are not allowed for security reasons.`, 'error');
      event.target.value = '';
      return;
    }
    const typeGroup = inferDocType(file.type);
    if (!typeGroup) {
      showSnackBar(`Unsupported file type (${file.type || ext}).`, 'error');
      event.target.value = '';
      return;
    }

    const limit = WHATSAPP_LIMITS[typeGroup];
    if (file.size > limit) {
      showSnackBar(
        `File too large for ${typeGroup}. Max ${bytesToMB(limit)} MB. Your file is ${bytesToMB(file?.size)} MB.`,
        'error'
      );
      event.target.value = '';
      return;
    }
    let form = new FormData();
    form.append('file', file);
    await leadFormActions.uploadLeadImageById(leadDetails?.id, form);
  };

  const getAudioById = async () => {
    setAudioModalShow(true);
    let res = await leadFormActions.getLeadAudioById(leadDetails?.id);
    setAudioList(res?.data?.audio_list || []);
  };

  const handleAudioFile = async (event) => {
    let file = event?.target?.files[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();
    const ext = fileName.split('.').pop();

    // Check for blocked extensions
    if (BLOCKED_EXTENSIONS.has(ext)) {
      showSnackBar(`"${ext}" files are not allowed for security reasons.`, 'error');
      event.target.value = '';
      return;
    }

    // Determine type group
    const typeGroup = inferDocType(file.type);
    if (typeGroup !== 'audio') {
      showSnackBar(
        `Unsupported file type (${file.type || ext}). Please upload an audio file.`,
        'error'
      );
      event.target.value = '';
      return;
    }

    // Check size limit
    const limit = WHATSAPP_LIMITS.audio;
    if (file.size > limit) {
      showSnackBar(
        `File too large. Max ${bytesToMB(limit)} MB. Your file is ${bytesToMB(file.size)} MB.`,
        'error'
      );
      event.target.value = '';
      return;
    }

    // Upload
    try {
      let form = new FormData();
      form.append('file', file);
      await leadFormActions.uploadLeadAudioById(leadDetails?.id, form);
      showSnackBar('Audio uploaded successfully!', 'success');
      event.target.value = ''; // Clear input after success
    } catch (err) {
      showSnackBar(err?.toString() || 'Upload failed', 'error');
      event.target.value = '';
    }
  };

  // const onsubmitComment = async (e) => {
  //   let res = await leadFormActions.postCommentById({ comment: e,id }, leadDetails?.id);
  //   if (res?.status) {
  //     setComment('');
  //   }
  // };
  const onsubmitComment = async (commentText) => {
    try {
      if (commentText) {
        const response = await leadFormActions.postCommentById(
          { comment: commentText, id: leadDetails?.id },
          leadDetails?.id
        );
        if (response && response.status === 200) {
          setLeadDetail((prev) => ({
            ...prev,
            comment: {
              comment: commentText,
              created_at: new Date(),
              created_by: loggedInUser?.username ?? 'You',
            },
          }));
          setCommentList([
            ...(commentList || []),
            {
              comment: commentText,
              created_at: new Date(),
              created_by: loggedInUser?.username ?? 'You',
            },
          ]);
          showSnackBar('Comment added successfully', 'success');
        } else {
          showSnackBar('Failed to add comment', 'error');
        }
      }
    } catch (error) {
      showSnackBar(error?.toString() || 'Error', 'error');
    }
  };

  const getCommentById = async (id) => {
    setCommentList([]);
    if (!id) return;
    try {
      let res = await leadFormActions.getCommentById(id);
      setCommentList(res?.data?.internal_comments);
      setShowLastComment(true);
    } catch (err) {
      showSnackBar(err?.toString() || 'Error', 'error');
    }
  };

  const onSubmitReference = async (data) => {
    await leadFormActions.addReferences(data, leadDetails?.id);
  };

  const getCampaigns = async (filter) => {
    setIsDataLoading(true);
    let res = await campaignActions.getCampaignAssignment(filter);
    setIsDataLoading(false);
    setCampaignList(res);
  };

  const saveCallDataObj = async () => {
    if (knowlarityApiResData?.type === 'CDR') {
      setCdrDataIsSaving(true);
      try {
        const leadWebFormData = JSON.parse(localStorage.getItem('leadWebFormData')) || {};
        let data = {
          ...knowlarityApiResData,
          campaign_id: leadWebFormData?.campaign?.proposal_id || '',
        };
        let res = await leadFormActions.updateInterveneCdrData(data);
        if (res?.status === 200) {
          setKnowlarityApiResData({});
          setDispositionModalShow(false);
          // setIsTimerActive(false);
          showSnackBar('Status updated successfully', 'success');
        } else {
          showSnackBar('An error occurred while updating status.', 'error');
        }
      } catch (error) {
        showSnackBar(error?.toString(), 'error');
      } finally {
        setCdrDataIsSaving(false);
      }
      // setTimerForSaveCdr(120);
    }
  };

  const createCdrData = async (newData) => {
    let res = await leadFormActions.postInterveneCdrData(newData);
    if (res?.status === 200) {
      showSnackBar(res?.data?.data || 'Disposition created successfully', 'success');
    } else {
      showSnackBar('An error occurred while creating disposition.', 'error');
    }
  };

  React.useEffect(() => {
    const eventSource = new EventSource(
      'https://konnectprodstream4.knowlarity.com:8200/update-stream/36f4aedb-019c-4d6f-8fed-e7b223d2228e/konnect?source=router'
    );
    let num = loggedInUser?.mobile?.toString().slice(-10);
    let agentNumber = `+91${num}`;
    eventSource.onmessage = (event) => {
      const newData = JSON.parse(event.data);
      if (agentNumber === newData?.agent_number || agentNumber === newData?.destination) {
        // setDispositionModalShow(false);
        switch (newData?.type) {
          case 'AGENT_CALL':
          case 'AGENT_ANSWER':
          case 'HANGUP':
          case 'CUSTOMER_CALL':
            setKnowlarityApiResData(newData);
            break;
          case 'CUSTOMER_ANSWER':
            let customerNumber = newData?.customer_number.replace('+', '');
            handleSearch(customerNumber);
            setKnowlarityApiResData(newData);
            break;
          case 'CDR':
            const leadWebFormData = JSON.parse(localStorage.getItem('leadWebFormData')) || {};
            let data = { ...newData, campaign_id: leadWebFormData?.campaign?.proposal_id || '' };
            setKnowlarityApiResData(data);
            // setIsTimerActive(true);
            setDispositionModalShow(true);
            createCdrData(data);
            break;
          default:
            null;
        }
      }
    };
    eventSource.onerror = (error) => {
      eventSource.close();
    };

    return () => {
      eventSource.close();
    };
  }, []);

  const handleSubmitCampaignForm = (data) => {
    try {
      const leadWebFormData = JSON.parse(localStorage.getItem('leadWebFormData')) || {};
      if (data && Object.keys(data).length > 0) {
        localStorage.setItem('leadWebFormData', JSON.stringify(data));
        setCampaignFormModalProps({
          ...campaignFormModalProps,
          open: false,
          isEdit: false,
          formData: data,
        });
        setCampaignLeadManagementData((prev) => ({
          ...prev,
          selectedForm: data?.webForm ?? null,
          selectedCampaign: data?.campaign ?? null,
        }));
        getStatusList(data?.webForm?.leads_form_id);
        // setUserDetailByNumber((previous) => ({ ...previous, leadform_Id: data?.webForm?.leads_form_id, campaign_id: data?.campaign?.proposal_id }));
      } else if (leadWebFormData?.campaign?.name && leadWebFormData?.webForm?.leads_form_name) {
        setCampaignLeadManagementData((prev) => ({
          ...prev,
          selectedForm: leadWebFormData?.webForm ?? null,
          selectedCampaign: leadWebFormData?.campaign ?? null,
        }));
        setCampaignFormModalProps({
          ...campaignFormModalProps,
          open: false,
          isEdit: false,
          formData: leadWebFormData,
        });
        // setUserDetailByNumber((previous) => ({ ...previous, leadform_Id: leadWebFormData?.webForm?.leads_form_id, campaign_id: leadWebFormData?.campaign?.proposal_id }));
        if (leadWebFormData?.webForm?.leads_form_id)
          getStatusList(leadWebFormData?.webForm?.leads_form_id);
      }
      if (phone_number && isValidNumber(phone_number)) {
        leadWebFormData.phoneNumber = phone_number;
        localStorage.setItem('leadWebFormData', JSON.stringify(leadWebFormData));
        setSearchValue(phone_number);
        handleSearch(phone_number);
      }
      // else if (phone_number) {
      //   setIsEditCampaignForm(false);
      //   setUserDetailByNumber((previous) => ({ ...previous, leadform_Id: data?.webForm?.leads_form_id, campaign_id: data?.campaign?.proposal_id, lead_id: phone_number }));
      // }
      else if (leadWebFormData?.phoneNumber) {
        handleSearch(leadWebFormData.phoneNumber);
      }
    } catch (error) {
      console.warn(error, 'error');
    }
  };

  const handleSubmitCreateSupplierForm = (formData) => {
    setCreateSupplierModalProps((prev) => ({ ...prev, open: false }));
  };

  // React.useEffect(() => {
  //   try {
  //     const leadWebFormData = JSON.parse(localStorage.getItem('leadWebFormData')) || {};
  //     if (Object.keys(leadWebFormData).length <= 1) {
  //       setCampaignFormModalProps({ ...campaignFormModalProps, open: true, isEdit: false });
  //     } else if (leadWebFormData) {
  //       handleSubmitCampaignForm(leadWebFormData);
  //       // if (phone_number) {
  //       //   leadWebFormData.phoneNumber = phone_number;
  //       //   localStorage.setItem('leadWebFormData', JSON.stringify(leadWebFormData));
  //       //   handleSearch(phone_number);
  //       // } else if (leadWebFormData?.phoneNumber) {
  //       //   handleSearch(leadWebFormData.phoneNumber);
  //       // }
  //     }
  //     getRawLeadForm();
  //   } catch (error) {
  //     console.warn(error, 'error');
  //   }
  // }, []);

  React.useEffect(() => {
    try {
      const leadWebFormData = JSON.parse(localStorage.getItem('leadWebFormData')) || {};
      if (phone_number && isValidNumber(phone_number)) {
        setSearchValue(phone_number);
      }
      if (leadId && Object.keys(leadWebFormData).length <= 1) {
        setIsWaitingForLocalStorage(true);
        return;
      }

      if (!leadId && Object.keys(leadWebFormData).length <= 1) {
        setCampaignFormModalProps({ ...campaignFormModalProps, open: true, isEdit: false });
      } else if (leadWebFormData?.campaign?.name && leadWebFormData?.webForm?.leads_form_name) {
        handleSubmitCampaignForm(leadWebFormData);
        setIsWaitingForLocalStorage(false);
      }
      getRawLeadForm();
    } catch (error) {
      console.warn(error, 'error');
    }
  }, [leadId]);

  React.useEffect(() => {
    if (isWaitingForLocalStorage) {
      const leadWebFormData = JSON.parse(localStorage.getItem('leadWebFormData')) || {};
      if (leadWebFormData?.campaign?.name && leadWebFormData?.webForm?.leads_form_name) {
        handleSubmitCampaignForm(leadWebFormData);
        setIsWaitingForLocalStorage(false);
      }
    }
  }, [isWaitingForLocalStorage]);

  const setReferences = useSetRecoilState(referenceFieldAtom);
  const setFormEnable = useSetRecoilState(formEnableDisableAtom);

  const initBlankFormFromLocalStorage = () => {
    try {
      const leadWebFormData = JSON.parse(localStorage.getItem('leadWebFormData') || '{}');
      const localForm = leadWebFormData?.webForm;
      if (!localForm?.leads_form_items && !localForm?.data) return;

      const dynamicFormFields = staticColumnsMatch(
        Object.values(localForm?.leads_form_items ?? localForm?.data ?? {})
      );
      const dynamicFormGroups = localForm?.group_options || [];
      const groupedForm = groupLeadItems(dynamicFormFields, dynamicFormGroups);

      setDynamicLeadForm(groupedForm);
      setLeadFormTemplate(localForm?.templates ?? []);
      if (localForm?.reference) setReferences(localForm.reference);

      if (leadWebFormData?.campaign?.proposal_id && localForm?.leads_form_id) {
        setUserDetailByNumber((prev) => ({
          ...prev,
          leadform_Id: localForm.leads_form_id,
          campaign_id: leadWebFormData.campaign.proposal_id,
          phone_number: leadWebFormData.phoneNumber || prev?.phone_number || '',
        }));
      }
    } catch (error) {
      console.warn('Error initializing blank form:', error);
    }
  };

  const processLeadData = (data, userRawLeadData = null) => {
    try {
      setLeadDetail(data);
      const leadWebFormData = JSON.parse(localStorage.getItem('leadWebFormData') || '{}');
      const localData = leadWebFormData?.webForm;
      const dynamicFormFields = staticColumnsMatch(
        Object.values(localData?.leads_form_items ?? localData?.data ?? {})
      );
      if (data?.id) setFormEnable(true);
      setLeadFormTemplate(localData?.templates ?? []);

      if (localData?.reference) setReferences(localData?.reference);
      const dynamicFormGroups = localData?.group_options;
      const sourceData = data?.data ?? [];
      const fieldMap = new Map(sourceData.map((item) => [item.key_name, item]));
      const populated = (dynamicFormFields || []).map((field) => {
        const source = fieldMap.get(field && field.key_name);

        return {
          ...field,
          value: (source && source.value) ?? field.value ?? '',
          status_config: (source && source.status_config) ?? field.status_config ?? null,
          entity_data: (source && source.entity_data) ?? field.entity_data ?? null,
        };
      });
      const groupedForm = groupLeadItems(populated, dynamicFormGroups);
      setDynamicLeadForm(groupedForm);
    } catch (err) {
      showSnackBar('Error:', err?.toString());
    }
  };

  useEffect(() => {
    if (userDetailByNumber?.campaign_id && userDetailByNumber?.leadform_Id) {
      setUserDetail({
        whatsapp_name: userDetailByNumber?.person_name || '',
        phone_number: userDetailByNumber?.phone_number || '',
      });
    }
  }, [userDetailByNumber]);

  return (
    <>
      {campaignFormModalProps?.formData?.campaign?.name &&
        campaignFormModalProps?.formData?.webForm?.leads_form_name && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '8px',
              border: '1px solid #D9D9D9',
              borderRadius: '4px',
              width: '100%',
              backgroundColor: '#F1F1F3',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              mb: 0.5,
              height: '44px',
              mt: { sm: 0, xs: 1 },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <IconButton
                onClick={() => {
                  navigate(-1);
                }}
                size="medium"
                sx={{
                  color: 'secondary.main',
                  marginRight: 0,
                  padding: '0px',
                }}
              >
                <WestOutlinedIcon />
              </IconButton>

              <Typography
                component="span"
                variant="h5"
                marginRight="49px"
                sx={{ fontWeight: 'bold', color: 'secondary.main', fontSize: '16px' }}
              >
                <EllipsisWithTooltip
                  text={`${campaignFormModalProps?.formData?.campaign?.name} (${campaignFormModalProps?.formData?.webForm?.leads_form_name})`}
                  fontWeight="bold"
                  color="secondary.main"
                  fontSize="16px"
                />
              </Typography>
            </Box>
            <Box>
              {!leadId && (
                <IconButton
                  onClick={() => {
                    setCampaignFormModalProps({
                      ...campaignFormModalProps,
                      open: true,
                      isEdit: true,
                    });
                  }}
                  size="medium"
                  sx={{
                    color: 'secondary.main',
                    padding: '0px',
                  }}
                >
                  <EditOutlinedIcon />
                </IconButton>
              )}
            </Box>
          </Box>
        )}

      <Box
        width={'100%'}
        sx={{
          borderStyle: 'solid',
          borderColor: '#EAEAEA',
          borderWidth: '0px 1px 1px 1px',
          marginTop: '-3px',
        }}
      >
        <div className="left-info-sidebar detail_container left-search-box">
          <Box>
            {!leadId ? (
              <SearchBox
                onSearch={handleSearch}
                value={searchValue}
                placeholder="Enter Phone Number"
              />
            ) : (
              <Box pt={1}>
                <TextField
                  disabled
                  id="phoneNumberDisable"
                  label="Phone Number"
                  size="small"
                  value={searchValue}
                  defaultValue={searchValue}
                  fullWidth
                  placeholder="Phone Number"
                  sx={{ color: 'primary.main', fontWeight: 500 }}
                />
              </Box>
            )}
          </Box>
          {!leadId && (
            <Box mt={1}>
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  setLeadDetail({});
                  setUserDetail({});
                  resetDynamicForm();
                  setFormEnable(false);
                  initBlankFormFromLocalStorage();
                }}
              >
                Create Lead
              </Button>
            </Box>
          )}
          {/* {!userDetailByNumber?.leadId && */}
          <Box marginTop="24px">
            <LeadsDropdown
              value={leadDetails}
              onChange={(e) => {
                processLeadData(e, userRawLeadData);
                getCommentById(e?.id);
                if (onLeadClick) onLeadClick();
              }}
              campaignId={userDetailByNumber?.campaign_id}
              leadFormId={userDetailByNumber?.leadform_Id}
              phoneNumber={userDetailByNumber?.phone_number}
              label="Select Lead"
              sx={{ mb: 1, mt: 1 }}
              multiSelect={false}
              // statusList={statusList ?? []}
              leadId={leadId}
            // disabled={userDetailByNumber?.leadId ? true : false}
            />
          </Box>
          <Box marginTop="14px">
            <Accordion
              sx={{
                boxShadow: 'none',
                borderStyle: 'solid',
                borderWidth: '1px',
                borderColor: '#EAEAEA',
              }}
              expanded={accordianKey === '0'}
              onChange={() => setAccordianKey((prev) => (prev === '0' ? null : '0'))}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: '#0b6bc' }} />}
                className="Accordian-detail-wrapper"
              >
                <Typography sx={{ color: 'text.main' }}>Lead Form Info:</Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  overflow: 'auto',
                  height: { xs: 'auto', sm: 'auto', md: 'auto' },
                  padding: '10px 8px',
                }}
              >
                <Box display="flex" justifyContent={'space-between'}>
                  <Typography
                    fontWeight={500}
                    sx={{
                      minWidth: '60px',
                      fontSize: '14px',
                      color: '#4F5457',
                      fontWeight: 500,
                    }}
                  >
                    Total Submitted :
                  </Typography>
                  <Typography
                    color="text.secondary"
                    sx={{ fontSize: '14px', color: '#4F5457', fontWeight: 500 }}
                  >
                    {leadCounts?.total_leads || 0}
                  </Typography>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Box>
          <Box
            display="flex"
            my={3}
            flexDirection="column"
            alignItems={'left'}
            border="1px solid #EAEAEA"
            borderRadius="4px"
            padding={'10px 8px'}
            height="max-content"
          >
            <Typography
              fontWeight={500}
              sx={{
                minWidth: '60px',
                fontSize: '14px',
                color: 'secondary.main',
                mb: 1,
              }}
            >
              Requirement Gatherer :
            </Typography>
            <Typography color="secondary.main" sx={{ fontSize: '0.90rem', paddingRight: '8px' }}>
              {userDetailByNumber?.rg_name || leadDetails?.rg_name || loggedInUser?.username}
            </Typography>
          </Box>
          {leadDetails?.id && (
            <>
              {/* ----------- Image Upload Section ----------- */}
              <Box sx={{ border: '1px solid #EAEAEA', mt: 3, p: '10px 8px', borderRadius: '4px' }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Typography sx={{ color: 'text.main' }}>Images</Typography>

                    <Box
                      sx={{
                        border: '2px dashed #B4B6BA',
                        padding: '10px 15px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                        borderRadius: 1,
                        transition: 'background-color 0.3s ease',
                        '&:hover': { backgroundColor: '#e3f2fd' },
                        flexDirection: 'column',
                        textAlign: 'center',
                        my: 2,
                        height: '92px',
                      }}
                      onClick={() => document.getElementById('image-upload')?.click()}
                    >
                      <CloudUploadOutlinedIcon sx={{ fontSize: '20px', color: '#1976d2' }} />
                      <input
                        type="file"
                        id="image-upload"
                        accept="image/png, image/gif, image/jpeg"
                        onChange={handleFileSelect}
                        style={{ display: 'none' }}
                      />
                      <Typography variant="body2" color="textSecondary">
                        <Box sx={{ fontWeight: '500', fontSize: '14px', color: 'text.main' }}>
                          Choose a file
                        </Box>
                        <span style={{ fontSize: '0.9rem', color: '#616161' }}>
                          Supports JPG, PNG, GIF (Max 5 MB)
                        </span>
                      </Typography>
                    </Box>
                    <Button variant="contained" size="small" onClick={() => getImagesById()}>
                      View
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography sx={{ color: 'text.main' }}>Recordings</Typography>
                    <Box
                      sx={{
                        border: '2px dashed #B4B6BA',
                        padding: 3,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                        borderRadius: 1,
                        transition: 'background-color 0.3s ease',
                        '&:hover': { backgroundColor: '#e3f2fd' },
                        flexDirection: 'column',
                        textAlign: 'center',
                        my: 2,
                        height: '92px',
                      }}
                      onClick={() => document.getElementById('audio-upload')?.click()}
                    >
                      <CloudUploadOutlinedIcon sx={{ fontSize: '20px', color: '#1976d2' }} />
                      <input
                        type="file"
                        id="audio-upload"
                        accept="audio/*"
                        onChange={handleAudioFile}
                        style={{ display: 'none' }}
                      />
                      <Typography variant="body2" color="textSecondary">
                        <Box sx={{ fontWeight: '500', fontSize: '14px', color: 'text.main' }}>
                          Choose a file
                        </Box>
                        <span style={{ fontSize: '0.9rem', color: '#616161' }}>
                          Supports audio• Max 16 MB
                        </span>
                      </Typography>
                    </Box>
                    <Button variant="contained" size="small" onClick={() => getAudioById()}>
                      View
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </>
          )}

          <Box
            sx={{
              border: '1px solid #EAEAEA',
              mt: 3,
              p: '8px 10px',
              borderRadius: '4px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItem: 'center',
            }}
          >
            <Typography sx={{ mt: 2, fontWeight: '500', color: 'text.main' }}>Comments</Typography>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'right' }}>
              <Typography
                fontSize="12px"
                color="secondary.main"
                fontWeight="400"
                sx={{ cursor: 'pointer' }}
                onClick={() => {
                  setShowLastComment(!showLastComment);
                  // if (showLastComment) {
                  //   getCommentById(leadDetails?.id);
                  // }
                }}
              >
                {showLastComment
                  ? `View All Comments ${commentList?.length ? `(${commentList.length})` : ''}`
                  : `Hide All Comments`}
              </Typography>
            </Box>
          </Box>
          {leadDetails?.comment?.comment && showLastComment && (
            <CommentBox
              commentList={[leadDetails?.comment]}
              onSubmitComment={(e) => onsubmitComment(e)}
            />
          )}
          {!showLastComment && (
            <Box>
              <CommentBox commentList={commentList} onSubmitComment={(e) => onsubmitComment(e)} />
            </Box>
          )}
          {/* <Box
            sx={{
              border: '1px solid #EAEAEA',
              mt: 3,
              p: '8px 10px',
              borderRadius: '4px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItem: 'center',
            }}
          >
            <Typography sx={{ mt: 2, fontWeight: '500', color: 'text.main' }}>
              Assign Users
            </Typography>
            {leadDetails?.lead_assignment?.length > 0 && (
              <Box mb={2}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Currently Assigned:
                </Typography>
                <Stack direction="row" spacing={1} flexWrap="wrap">
                  {leadDetails?.lead_assignment.map((user, idx) => (
                    <CommonBadges
                      color="success"
                      value={user?.username || user?.name || 'Unknown User'}
                      variant="outlined"
                    />
                  ))}
                </Stack>
              </Box>
            )}
            <Typography
              fontSize="12px"
              color="secondary.main"
              fontWeight="400"
              sx={{ cursor: 'pointer' }}
              onClick={() => setAssignModalOpen(true)}
            >
              Assign & Unassign
            </Typography>
          </Box> */}
        </div>
      </Box>
      {modalShow && (
        <ModalForms
          show={modalShow}
          handleClose={() => setModalShow(false)}
          modalBody={<ImageModal imagesList={imagesList || []} />}
          modalHeader="Images"
          modalId="Images"
          modalclassName=""
          size=""
        />
      )}

      {audioModalShow && (
        <ModalForms
          show={audioModalShow}
          handleClose={(e) => {
            setAudioModalShow(!audioModalShow);
          }}
          modalBody={AudioModal(audioList)}
          modalHeader={'Audio'}
          modalId={'audioModal'}
          modalclassName={''}
          size=""
        />
      )}

      {dispositionModalShow && (
        <ModalForms
          show={dispositionModalShow}
          handleClose={(e) => {
            setDispositionModalShow(!dispositionModalShow);
          }}
          modalBody={<DispositionModal />}
          modalHeader={'Add Disposition'}
          modalId={'addDisposition'}
          modalclassName={''}
          size=""
          backdrop="static"
          modalFooter={
            <>
              <LoadingButton
                buttonName="Save"
                isDisabled={cdrDataIsSaving}
                isLoading={cdrDataIsSaving}
                onClickButton={() => {
                  saveCallDataObj();
                }}
              />
              {/* <Button variant="primary" onClick={() => saveCallDataObj()}>
                Save
              </Button> */}
              {/* {isTimerActive && <span>Auto-submitting in {timerForSaveCdr} seconds...</span>} */}
            </>
          }
        />
      )}
      {campaignFormModalProps?.open && (
        <CampaignFormSelectionModal
          open={campaignFormModalProps?.open}
          onClose={handleSubmitCampaignForm}
          isEdit={campaignFormModalProps?.isEdit || false}
          selectedCampaign={campaignFormModalProps?.formData?.campaign || null}
          selectedForm={campaignFormModalProps?.formData?.webForm || null}
        />
      )}
      {/* Create New User modal disabled; "No" flow runs automatically */}
      {/* <ConfirmBox
        open={confirmOpen}
        onClose={handleConfirm}
        options={{
          title: 'Create New User',
          text: 'Are you sure you want to create new user?',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          confirmButtonColor: 'error',
          cancelButtonColor: 'default',
        }}
      /> */}
      {/* {assignModalOpen && (
        <AssignLeadsModal
          open={assignModalOpen}
          onClose={() => {
            setAssignModalOpen(false);
          }}
          selectedLeads={{ [leadDetails?.lead_id]: true }}
          selectedRow={leadDetails}
          campaignId={campaignFormModalProps?.formData?.campaign?.proposal_id ?? ''}
          handleRefresh={(data) => {
            setLeadDetail((prev) => ({ ...prev, lead_assignment: data }));
          }}
        />
      )} */}

      {/* {createSupplierModalProps?.open &&
        <CreateSupplierModal open={createSupplierModalProps?.open} onClose={handleSubmitCreateSupplierForm} isEdit={createSupplierModalProps?.isEdit || false} />
      } */}
    </>
  );
}
